import { useStaticQuery, graphql } from 'gatsby'

const useMenu = () => {
  const {
    allMarkdownRemark: { nodes: menu },
  } = useStaticQuery(
    graphql`
      query MenuQuery {
        allMarkdownRemark(filter: { fields: { collection: { eq: "menu" } } }) {
          nodes {
            frontmatter {
              title
              menuItems {
                firstColumn {
                  name
                  price
                  description
                  addons {
                    name
                    price
                  }
                  subitems {
                    name
                    price
                  }
                }
                secondColumn {
                  name
                  price
                  description
                  addons {
                    name
                    price
                  }
                  subitems {
                    name
                    price
                  }
                }
                thirdColumn {
                  name
                  price
                  addons {
                    name
                    price
                  }
                  subitems {
                    name
                    price
                  }
                }
              }
              collections {
                name
                price
                description
                subitems {
                  name
                  description
                }
              }
            }
            html
          }
        }
      }
    `
  )

  return menu.map(m => ({ ...m.frontmatter, bodyHtml: m.html }))
}

export default useMenu
